var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11312 0.500985C5.25622 0.492102 5.39667 0.543605 5.50214 0.643641L9.61657 4.55649C9.75498 4.68875 9.81438 4.88705 9.7724 5.07667C9.73042 5.2663 9.59343 5.41844 9.41303 5.47579C9.23264 5.53314 9.03626 5.48697 8.89786 5.35468L5.14279 1.78489L1.38771 5.35468C1.24932 5.48697 1.05293 5.53314 0.872541 5.47579C0.692149 5.41844 0.555158 5.2663 0.513174 5.07667C0.471191 4.88705 0.530595 4.68875 0.669007 4.55649L4.78343 0.643641C4.87386 0.557998 4.99045 0.507546 5.11312 0.500985Z",
    fill: "#417FFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrowUp);
export default __webpack_public_path__ + "static/media/accordion_arrow_up.44535db5.svg";
export { ForwardRef as ReactComponent };